import Crud from '../components/ActionPlan/Crud'
import ActionPlan from '../components/ActionPlan/ActionPlan'
import Answer from '../components/Worker/ActionPlan/Answer'

let routes = {
    path: '/actionPlans',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/actionPlans',
          name: 'Planos de Ação',
          component: Crud
      },
      {
        path: '/actionPlan/:id?',
        name: 'Plano de Ação',
        component: ActionPlan
    },
    {
        path: '/action/actionPlan/:id',
        name: 'Responder Plano de Ação',
        component: Answer
    },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/actionPlan.js